import { BaseConfig } from "../config.interface";
import { Validate } from "../util";

interface ISelectButtonConfig {
    optionLabel?: string;
    optionValue?: string;
    multiple?: boolean;
    allowEmpty?: boolean;
    checkmark?: boolean;
    validate: Validate;
    size?: "full";

}
export class SelectButtonConfig extends BaseConfig<ISelectButtonConfig> implements ISelectButtonConfig {
    /**
     * Property key of the option's label.
     * Defaults to `label`.
     */
    optionLabel?: string;
    /**
     * Property key of the option's label.
     * Defaults to `value`.
     */
    optionValue?: string;
    /**
     * Property key of the option's disabled state.
     */
    optionDisabled?: string;
    /**
     * Determines if multiple values may be selected.
     */
    multiple?: boolean;
    /**
     * Determines if empty state is allowed and if selection can be unselected
     */
    allowEmpty?: boolean;
    /**
     * Determines if an additional checkmark should be added to the selected option's element
     */
    checkmark?: boolean;
    /**
     * Show validation status already in `pristine` state or after it has been marked as `dirty`.
     */
    validate: Validate;

    size?: "full";

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration. Only allows single selection.
         */
        Default: new SelectButtonConfig({
            allowEmpty: false,
            checkmark:  true,
            validate:   "dirty",
        }),

        /**
         * Allows multi value selection.
         */
        Multiple: new SelectButtonConfig({
            allowEmpty: true,
            checkmark:  true,
            validate:   "dirty",
            multiple:   true,
        }),
        MultipleNoCheckMark: new SelectButtonConfig({
            allowEmpty: true,
            checkmark:  false,
            validate:   "dirty",
            multiple:   true,
        }),

        /**
         * Only allows single selection.
         * Will not display the checkmark next to selected value.
         * 
         * Should be used to control different "views" on a page, not a value selection for a form.
         */
        View: new SelectButtonConfig({
            allowEmpty: false,
            checkmark:  false,
            validate:   "dirty",
        }),

        ViewFull: new SelectButtonConfig({
            allowEmpty: false,
            checkmark:  false,
            validate:   "dirty",
            size:       "full"
        }),
    };

}
